// French locale for AG Grid
export const agGridLocaleFr = {
  // Set Filter
  selectAll: '(Tout sélectionner)',
  selectAllSearchResults: '(Tout sélectionner dans les résultats de recherche)',
  searchOoo: 'Rechercher...',
  blanks: '(Vides)',
  noMatches: 'Aucun résultat',

  // Number Filter & Text Filter
  filterOoo: 'Filtrer...',
  equals: 'Égal à',
  notEqual: 'Différent de',
  blank: 'Vide',
  notBlank: 'Non vide',
  empty: 'Choisir un',

  // Number Filter
  lessThan: 'Inférieur à',
  greaterThan: 'Supérieur à',
  lessThanOrEqual: 'Inférieur ou égal à',
  greaterThanOrEqual: 'Supérieur ou égal à',
  inRange: 'Entre',
  inRangeStart: 'De',
  inRangeEnd: 'À',

  // Text Filter
  contains: 'Contient',
  notContains: 'Ne contient pas',
  startsWith: 'Commence par',
  endsWith: 'Se termine par',

  // Date Filter
  dateFormatOoo: 'yyyy-mm-dd',
  before: 'Avant',
  after: 'Après',

  // Filter Conditions
  andCondition: 'ET',
  orCondition: 'OU',

  // Filter Buttons
  applyFilter: 'Appliquer',
  resetFilter: 'Réinitialiser',
  clearFilter: 'Effacer',
  cancelFilter: 'Annuler',

  // Filter Titles
  textFilter: 'Filtre texte',
  numberFilter: 'Filtre nombre',
  dateFilter: 'Filtre date',
  setFilter: 'Filtre ensemble',

  // Side Bar
  columns: 'Colonnes',
  filters: 'Filtres',

  // Columns tool panel
  pivotMode: 'Mode pivot',
  groups: 'Groupes de lignes',
  rowGroupColumnsEmptyMessage: 'Glissez ici pour définir les groupes de lignes',
  values: 'Valeurs',
  valueColumnsEmptyMessage: 'Glissez ici pour agréger',
  pivots: 'Étiquettes de colonnes',
  pivotColumnsEmptyMessage: 'Glissez ici pour définir les étiquettes de colonnes',

  // Default Group Column
  group: 'Groupe',

  // Other
  loadingOoo: 'Chargement...',
  noRowsToShow: 'Aucune ligne à afficher',
  enabled: 'Activé',

  // Menu
  pinColumn: 'Épingler la colonne',
  pinLeft: 'Épingler à gauche',
  pinRight: 'Épingler à droite',
  noPin: 'Ne pas épingler',
  valueAggregation: 'Agrégation de valeurs',
  autosizeThiscolumn: 'Ajuster automatiquement cette colonne',
  autosizeAllColumns: 'Ajuster automatiquement toutes les colonnes',
  groupBy: 'Grouper par',
  ungroupBy: 'Dégrouper par',
  resetColumns: 'Réinitialiser les colonnes',
  expandAll: 'Tout développer',
  collapseAll: 'Tout réduire',
  copy: 'Copier',
  ctrlC: 'Ctrl+C',
  paste: 'Coller',
  ctrlV: 'Ctrl+V',
  export: 'Exporter',
  csvExport: 'Exporter en CSV',
  excelExport: 'Exporter en Excel',
  columnFilter: 'Filtre de colonne',
  columnChooser: 'Sélecteur de colonnes',
  sortAscending: 'Trier par ordre croissant',
  sortDescending: 'Trier par ordre décroissant',

  // Enterprise Menu Aggregation and Status Bar
  sum: 'Somme',
  min: 'Min',
  max: 'Max',
  none: 'Aucun',
  count: 'Nombre',
  avg: 'Moyenne',
  filteredRows: 'Filtré',
  selectedRows: 'Sélectionné',
  totalRows: 'Total des lignes',
  totalAndFilteredRows: 'Lignes',

  // Pivoting
  pivotColumnGroupTotals: 'Total',

  // Enterprise Menu (Charts)
  pivotChart: 'Graphique pivot',
  chartRange: 'Plage du graphique',

  chartSettings: 'Paramètres du graphique',
  chartData: 'Données du graphique',
  chartColumns: 'Colonnes',
  chartRows: 'Lignes',
  chartType: 'Type de graphique',
  chartXAxis: 'Axe X',
  chartYAxis: 'Axe Y',
  chartFormat: 'Format',
  chartAggFunc: 'Fonction d\'agrégation',

  // Enterprise Menu (Rich Select)
  richSelectFilter: 'Filtre',
  richSelectSelectAll: 'Tout sélectionner',
  richSelectSelectFiltered: 'Sélectionner filtré',
  richSelectNoMatches: 'Aucun résultat',
  richSelectBlanks: '(Vides)',

  // Standard Menu (additional filter options)
  noFilter: 'Aucun filtre',
  filterStartsWith: 'Commence par',
  filterEndsWith: 'Se termine par',
  filterContains: 'Contient',
  filterNotContains: 'Ne contient pas',
  filterAnd: 'ET',
  filterOr: 'OU',

  // Pagination
  page: 'Page',
  more: 'Plus',
  to: 'à',
  of: 'sur',
  next: 'Suivant',
  last: 'Dernier',
  first: 'Premier',
  previous: 'Précédent',
}

